var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content g9" },
    [
      _c("Accord", { attrs: { title: "Share" } }, [
        _c("h4", [_vm._v("Share your reports with third party")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      You may send a link to any third party, the link will automatically expire within 3 months.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c(
          "form",
          { ref: "shareForm", attrs: { autocomplete: "disabled" } },
          [
            _c("FormBuilder", {
              attrs: { formData: _vm.formData, formValue: _vm.formValue },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticStyle: { width: "100%", "min-height": "45px" } }, [
          _c("div", { staticStyle: { width: "50%", float: "left" } }, [
            _c(
              "button",
              {
                class: { loading: _vm.shareLoading },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onShareClick.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Share simulation")]
            ),
            _vm._v(" "),
            _vm.sharedDone
              ? _c("div", { staticStyle: { "font-weight": "bolder" } }, [
                  _vm._v("Simulation shared"),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                width: "50%",
                "text-align": "right",
                float: "right",
              },
            },
            [
              _c("button", { on: { click: _vm.onGetSharedUsers } }, [
                _vm._v("View shared"),
              ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.emailResults.length
        ? _c(
            "div",
            [
              _c(
                "Accord",
                { attrs: { title: "View sent emails", isClosed: "true" } },
                _vm._l(_vm.emailResults, function (emailResult) {
                  return _c("div", { staticClass: "grid-100w" }, [
                    _c("div", { staticClass: "grid-100w" }, [
                      _c("b", [_vm._v(_vm._s(emailResult.subject))]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "grid-100w" }, [
                      _vm._v(
                        "\n          " + _vm._s(emailResult.html) + "\n        "
                      ),
                    ]),
                  ])
                }),
                0
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showSharedUsers
        ? _c(
            "div",
            [
              _c("Accord", { attrs: { title: "Shared simulations" } }, [
                _vm.sharedUsers.length
                  ? _c("div", [
                      _c("table", { staticStyle: { width: "100%" } }, [
                        _c("thead", [
                          _c("tr", [
                            _c(
                              "th",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v("Email")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v("Created")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v("Updated")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v("Lastlogin")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v("Expires")]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.sharedUsers, function (user) {
                            return _c("tr", [
                              _c("td", [_vm._v(_vm._s(user.email))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(user.created))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(user.updated))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(user.lastLoggedIn))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(user.expires))]),
                            ])
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n          Please note, that you can only renew access by resending a user a new link. You cannot delete a share, it\n          will automatically expire.\n        "
                        ),
                      ]),
                    ])
                  : _c("div", [
                      _c("span", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v("There is currently no simulations shared."),
                      ]),
                    ]),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }